import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, Renderer2, SimpleChanges } from '@angular/core';
import { ThesaurusEntry } from '@interfaces/thesaurus-entry.interface';
import { TermsService } from '@terms-service/terms.service';
import { EntryService } from 'app/services/entry/entry.service';
import { ThesaurusService } from '../../services/thesaurus/thesaurus.service';

@Component({
    selector: 'app-collapsing-notes',
    templateUrl: './collapsing-notes.component.html',
    styleUrls: ['./collapsing-notes.component.scss'],
    standalone: false
})
export class CollapsingNotesComponent implements OnChanges {
    @Input() collapseId: string = "";
    @Input() entry!: ThesaurusEntry;
    @Input() thesaurusId: string = "";
    relatedTerm: string = "related";
  displayOverview?: string;
    @Output() collapseToggled = new EventEmitter<string>();

    constructor(
      public thesaurusService: ThesaurusService,
      public termsService: TermsService,
      private renderer: Renderer2,
      private cdr: ChangeDetectorRef,
      private entryService: EntryService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['entry']) {
        this.displayOverview = this.normalizeOverview(this.entry?.overview);
      }
    }

    closeBtn(elementId: string) {
        this.collapseToggled.emit(elementId);
    }

    normalizeOverview(overview?: string): string | undefined {
      if (!overview) {
        return overview;
      }

      let normalizedOverview = overview;

      if (normalizedOverview.startsWith('"')) {
        normalizedOverview = normalizedOverview.substring(1);
      }

      const paragraphIndex = normalizedOverview.indexOf('<p>');
      if (paragraphIndex !== -1) {
        normalizedOverview = normalizedOverview.substring(0, paragraphIndex);
      }

      return normalizedOverview;
    }

    onRelatedCheckboxChange(name: string, event: Event): void {
      const checkbox = event.target as HTMLInputElement;
      const isChecked = checkbox.checked;
      console.log(this.entry);
      this.termsService.updateList(name, this.relatedTerm, isChecked, this.entry!.notUnique, this.entry!.paths);
    }

    onEntryClick(ordinal: number): void {
      this.entryService.emitEntryClick(this.thesaurusId, ordinal);
    }

    showNarrowerTerms(): boolean {
      return this.thesaurusService.isBusinessThesaurus(this.thesaurusId);
    }

    showBroaderTerms(): boolean {
      return this.thesaurusService.isBusinessThesaurus(this.thesaurusId);
    }
}